import { Box, Button, CircularProgress, Dialog, DialogContent, DialogTitle, Fade, Typography } from "@mui/material";

import "../../styles/registerModal.css";
import InputStyle from "../../assets/InputStyle";
import EnterOtpModal from "./EnterOtpModal";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { register } from "../../actions/userAuth";
import LoginModal from "./LoginModal";
import img1 from "../../images/flagIcon.png";
import NumberInput from "../../utils/NumberInput";
import { isValidPhoneNumber, isValidPhoneNumberWithoutCode, isValidateEmail } from "../../utils/common";
import CloseIcon from '@mui/icons-material/Close';
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { enqueueSnackbar } from "notistack";
import NumberInputFullWidth from "../../utils/NumberInputFullWidth";

export default function RegisterModal({
  role,
  addRegisterModalAction,
  setAddRegisterModalAction,
}) {
  const dispatch = useDispatch();
  const [addEnterOtpAction, setAddEnterOtpAction] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [receiveUpdates, setReceiveUpdates] = useState(false);
  const [agreePrivacyPolicy, setAgreePrivacyPolicy] = useState(false);
  const [addLoginAction, setAddLoginAction] = useState(false);
  const [countryCode, setCountryCode] = useState([]);
  const [emailToken, setEmailToken] = useState("");
  const [phoneToken, setPhoneToken] = useState("");
  const [emailError, setEmailError] = useState(false)
  const [phoneError, setPhoneError] = useState(false)
  const [passwordError, setPasswordError] = useState(false)
  const [confirmPasswordError, setConfirmPasswordError] = useState(false)
  const [active, setActive] = useState(false)
  const [passwordVisibility, setPasswordVisibility] = useState(false);
  const [confirmPasswordVisibility, setConfirmPasswordVisibility] = useState(false);
  const [loading, setLoading] = useState(false);
  const closeHandler = (event, reason) => {
    if (reason && reason == "backdropClick")
      return;
    setAddRegisterModalAction(false);
  }

  const handlePasswordVisibility = (id, state, setState) => {
    if (state) {
      document.getElementById(id).type = "password";
    } else {
      document.getElementById(id).type = "text";
    }
    setState(!state);
  }


  const handleInputChange = (e, setState) => {
    if (setState == setAgreePrivacyPolicy || setState == setReceiveUpdates) {
      console.log("function", e.target.checked)
      setState(e.target.checked);
    }
    else {
      console.log("state")
      setState(e.target.value)
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    let payload = {
      email: email,
      name: companyName,
      phone: `${countryCode}${mobileNumber}`,
      password: confirmPassword,
      role: role,
    };
    dispatch(
      register(payload, (data) => {
        console.log("Here is Data:", data.data);
        console.log(data.data.data.emailOtpToken);
        setLoading(false);
        enqueueSnackbar("OTP sent successfully", { variant: 'success' });
        setEmailToken(data.data.emailOtpToken);
        setPhoneToken(data.data.phoneOtpToken);
        closeHandler();
        setAddEnterOtpAction(true);
      }, (err) => {
        enqueueSnackbar("Error Occured! please try again later", { variant: 'error' });
        setLoading(false);
      })
    );
    // Handle form submission logic here
  };

  useEffect(() => {
    if (email) {
      const emailError = isValidateEmail(email)
      setEmailError(emailError)
    }
    if (mobileNumber) {
      const phoneErr = isValidPhoneNumberWithoutCode(mobileNumber)
      setPhoneError(phoneErr)
    }
    if (companyName.length > 2 && email && mobileNumber && password.length > 5 && confirmPassword === password && receiveUpdates && agreePrivacyPolicy) {
      setActive(true)
    }
    else {
      setActive(false)
    }
  }, [companyName, email, mobileNumber, confirmPassword, password, receiveUpdates, agreePrivacyPolicy])

  return (
    <>
      <Dialog
        open={addRegisterModalAction}
        onClose={closeHandler}
        TransitionComponent={Fade}
        transitionDuration={500}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <CloseIcon sx={{ float: 'right', cursor: 'pointer' }} onClick={closeHandler} />
        </DialogTitle>
        <DialogContent className="hideScrollBar">
          <div className="registerModal">
            <div className="registerModal-box">
              <div className=" registerModal-content">
                <div className=" registerModal-body">
                  <div style={{ textAlign: "center" }}>
                    <span className="registerModal-span1">
                      Join us to sign in!
                    </span>
                  </div>
                  <form>
                    <div>
                      <InputStyle name={role == "EMPLOYER" ? "Company Name" : "Name"} topSpace={true}>
                        <input
                          type="text"
                          placeholder={role == "EMPLOYER" ? "Enter Your Company Name" : "Enter Your Name"}
                          value={companyName}
                          onChange={(e) => handleInputChange(e, setCompanyName)}
                          style={{color:'black',width:"100%"}}
                        />
                      </InputStyle>
                     
                      <InputStyle name="Email" topSpace={true}>
                        <input
                          type="text"
                          placeholder="Enter Your Email"
                          value={email}
                          onChange={(e) => handleInputChange(e, setEmail)}
                          style={{color:'black',width:"100%"}}
                        />
                      </InputStyle>
                      {email.length > 2 & !emailError ? <Typography className="text1Mid" sx={{ fontWeight: "400", color: "red" }}>Enter a valid email</Typography> : ""}


                      <Typography
                        component="label"
                        sx={{
                          fontWeight: 600,
                          fontFamily: "Inter",
                          fontSize: 14,
                        }}
                      >
                        Mobile Number
                      </Typography>
                      <NumberInputFullWidth setCountryCode={setCountryCode} mobileNumber={mobileNumber} setMobileNumber={setMobileNumber} />

                      <InputStyle name="Password" topSpace={true}>
                        <input
                          id={"password"}
                          type="password"
                          placeholder="Enter your password"
                          value={password}
                          onChange={(e) => handleInputChange(e, setPassword)}
                          style={{color:'black',width:"100%"}}
                        />
                        {
                          passwordVisibility
                            ?
                            <Visibility onClick={() => handlePasswordVisibility("password", passwordVisibility, setPasswordVisibility)} style={{ marginLeft: '-30px', cursor: 'pointer' }} />
                            :
                            <VisibilityOff onClick={() => handlePasswordVisibility("password", passwordVisibility, setPasswordVisibility)} style={{ marginLeft: '-30px', cursor: 'pointer' }} />
                        }
                        {password.length > 0 && password.length < 6 ? <Typography className="text1Mid" sx={{ fontWeight: "400", color: "red" }}>Password should be more than 5 characters</Typography> : ""}

                      </InputStyle>
                      <InputStyle name="Confirm Password" topSpace={true}>
                        <input
                          id={"confirmPassword"}
                          type="password"
                          placeholder="Re-enter your password"
                          value={confirmPassword}
                          onChange={(e) =>
                            handleInputChange(e, setConfirmPassword)
                          }
                          style={{color:'black',width:"100%"}}
                        />
                        {
                          confirmPasswordVisibility
                            ?
                            <Visibility onClick={() => handlePasswordVisibility("confirmPassword", confirmPasswordVisibility, setConfirmPasswordVisibility)} style={{ marginLeft: '-30px', cursor: 'pointer' }} />
                            :
                            <VisibilityOff onClick={() => handlePasswordVisibility("confirmPassword", confirmPasswordVisibility, setConfirmPasswordVisibility)} style={{ marginLeft: '-30px', cursor: 'pointer' }} />
                        }
                      </InputStyle>
                      {confirmPassword.length > 0 && confirmPassword !== password ? <Typography className="text1Mid" sx={{ fontWeight: "400", color: "red" }}>Not matching with password.</Typography> : ""}


                      <div className="registerModal-div2">
                        <input
                          type="checkbox"
                          id="firstCheck"
                          required
                          checked={receiveUpdates}
                          onChange={(e) =>
                            handleInputChange(e, setReceiveUpdates)
                          }
                          // style={{color:'black',width:"100%"}}
                        />
                        <label for="firstCheck" className="registerModal-label2">
                          I want to receive product updates, marketing news, and
                          other relevant content by
                          <a href="/">Whatsapp or SMS. </a>
                        </label>
                      </div>
                      <div className="registerModal-div2">
                        <input
                          type="checkbox"
                          id="secondCheck"
                          required
                          checked={agreePrivacyPolicy}
                          onChange={(e) =>
                            handleInputChange(e, setAgreePrivacyPolicy)
                          }
                          // style={{color:'black',width:"100%"}}
                        />
                        <label for="secondCheck" className="registerModal-label2">
                          I agree and understand that <a href="/">PPLACD</a> may
                          process, store, and share my personal information in
                          accordance with the Privacy Policy.
                        </label>
                      </div>
                      <div >
                        {active ?
                          <Button
                            type="submit"
                            variant="contained"
                            fullWidth
                            disabled={loading}
                            onClick={(e) => handleSubmit(e)}
                            sx={{ bgcolor: "#2544EE", mt: 1, width: '100%',borderRadius:2,textTransform:'none' }}
                          >
                            {
                              loading
                                ?
                                <CircularProgress size={24} />
                                :
                                "Sign Up"
                            }
                          </Button> :
                          <Button
                            type="submit"
                            variant="contained"
                            disabled={true}
                            fullWidth
                            sx={{ bgcolor: "#2544EE", mt: 2, width: '100%',borderRadius:2,textTransform:'none' }}
                          >
                            Sign Up
                          </Button>
                        }

                        <div className="registerModal-div3">
                          <span className="signUpModal-span4">
                            Already have an account?
                            <a
                              onClick={() => {
                                setAddLoginAction(true);
                                closeHandler();
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              Login
                            </a>
                          </span>
                        </div>
                      </div>
                    </div>

                  </form>
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
      <EnterOtpModal
        emailToken={emailToken}
        phoneToken={phoneToken}
        addEnterOtpAction={addEnterOtpAction}
        setAddEnterOtpAction={setAddEnterOtpAction}
      />
      <LoginModal
        addLoginAction={addLoginAction}
        setAddLoginAction={setAddLoginAction}
      />
    </>
  );
}
